import { DateTime } from "luxon";
import { History } from "lucide-react";
import { Button } from "../ui/button";

/** Bandeau affiché quand un formulaire a repris un brouillon local (`useFormDraft`). */
export function FormDraftNotice({ restoredAt, onDiscard }: { restoredAt: Date | null; onDiscard: () => void }) {
    if (!restoredAt) return null;
    const savedAt = DateTime.fromJSDate(restoredAt).setLocale("fr");
    return (
        <div role="status" className="mt-2 flex flex-wrap items-center gap-2 rounded-md bg-blue-50 px-3 py-2 text-sm text-blue-900">
            <History className="h-4 w-4 shrink-0" />
            <span>
                Brouillon restauré (saisi le {savedAt.toFormat("dd/MM/yyyy")} à {savedAt.toFormat("HH:mm")})
            </span>
            <Button type="button" variant="link" size="sm" className="h-auto p-0 text-blue-900 underline" onClick={onDiscard}>
                Effacer le brouillon
            </Button>
        </div>
    );
}
